import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  VideoPresentation, AboutPeople, AboutAdvance, SellingBlockModules, Founder, PurpleBanner, VideoReviews, HeroModules, Modules, LearnMore, Level, Problems, Result, mainOld
} from "../../../components/LandingTemplates/uchis_uchitsya"

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterMedium } from '../../../components/FooterMedium';

import methodistsData from '../../../components/LandingTemplates/uchis_uchitsya/data/methodistsDataOld.json';
import videoReviewsData from '../../../components/LandingTemplates/uchis_uchitsya/data/videoReviewsDataOld.json';

const TITLE = 'Онлайн-курс «Учись учиться» — как воспитать гармонично развитого ребёнка?';
const DESCRIPTION = '«Учись Учиться» — онлайн-курс для эффективного развития мышления ребёнка, который научит учиться самостоятельно и с удовольствием';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <HeroModules
        buttonText={'Пробовать бесплатно'}
        widget={<GetCourseWidget hash={'5617e9da62cfe7c59c2e611239ce370c463d53da'} id={'652643'} />}
      />
      <VideoPresentation showButton={false} />
      <LearnMore />
      <Problems />
      <PurpleBanner />
      <Result />
      <Level />
      <Modules
        buttonText={'Оставить заявку'}
        widget={<GetCourseWidget hash={'5617e9da62cfe7c59c2e611239ce370c463d53da'} id={'652643'} />}
      />
      <AboutPeople
        data={methodistsData}
        title={'Над курсом трудились методисты, преподаватели, разработчики'}
        titleClassName={mainOld.aboutPeople__title}
        bottomText={'и еще 90+ специалистов'}
        bottomTextClassName={mainOld.aboutPeople__bottomText}
      />
      <AboutAdvance titleClassName={`${mainOld.titleH2} ${mainOld.blockTitle}`} />
      <Founder />
      <SellingBlockModules
        title={
          'Бесплатный пробный доступ к курсу «Учись Учиться 8-11 класс» для тех, кто хочет убедиться, что наши технологии действительно работают'
        }
        description={'7 дней — БЕСПЛАТНО!'}
        buttonText={'Получить доступ к курсу'}
        hiddenBtn={true}
        widget1={<GetCourseWidget hash={'5617e9da62cfe7c59c2e611239ce370c463d53da'} id={'652643'} />}
      />
      <VideoReviews data={videoReviewsData} showButton={false} />
    </main>

    <FooterMedium />
  </DefaultLayout>
);

export default Page;
